import {z as r} from 'zod';

import {
    ReviewConcordanceRequestFieldEnum,
    ReviewConcordanceRequestType,
} from '../../../../../../service/reivew-analysis/review-concordance/review-concordance-type';

export type ConcordanceFormType = Pick<
    ReviewConcordanceRequestType,
    ReviewConcordanceRequestFieldEnum.Query | ReviewConcordanceRequestFieldEnum.ContextSize
> & {
    [ReviewConcordanceRequestFieldEnum.Range]: [Date | null, Date | null];
};

export const autoCompleteOptionsZodSchema = r.array(
    r.object({
        value: r.string(),
    })
);
